import { render, staticRenderFns } from "./HeadTaxableTotal.vue?vue&type=template&id=b8a3c2a8"
import script from "./HeadTaxableTotal.vue?vue&type=script&lang=js"
export * from "./HeadTaxableTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports